export const trimMask = (value: string) => value.replace(/\s+/g, "").trim();

export function parseInputList(input: string) {
  return input
    .replace(/[\s,]+/g, ",")
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
}

export const codeIssuerMask = (value: string) => {
  return value.replace(/(\d{3})(\d{3})/, "$1-$2");
};
